export const ERE_SEASON = '2024/25';
export const ERE_CURRENT_GW = 20;
export const ERE_TOTAL_GW = 30;
export const ERE_STANDINGS = [
    { pos:1, name:'Ajax Vrouwen',     short:'AJX', color:'#DC0714', p:20, w:16, d:2, l:2, gf:58, ga:18, form:['W','W','W','D','W'], zone:'cl', pts:50 },
    { pos:2, name:'FC Twente W',      short:'TWE', color:'#E4000F', p:20, w:15, d:3, l:2, gf:52, ga:20, form:['W','D','W','W','W'], zone:'cl', pts:48 },
    { pos:3, name:'PSV Vrouwen',      short:'PSV', color:'#E30613', p:20, w:13, d:2, l:5, gf:45, ga:25, form:['W','L','W','W','D'], zone:'cl', pts:41 },
    { pos:4, name:'Feyenoord V',      short:'FEY', color:'#CC0000', p:20, w:11, d:3, l:6, gf:38, ga:28, form:['W','W','L','D','W'], zone:'',   pts:36 },
    { pos:5, name:'Utrecht Vrouwen',  short:'UTR', color:'#FFCC00', p:20, w:9,  d:4, l:7, gf:32, ga:30, form:['D','W','W','L','W'], zone:'',   pts:31 },
    { pos:6, name:'AZ Vrouwen',       short:'AZV', color:'#CC0000', p:20, w:7,  d:3, l:10,gf:27, ga:35, form:['L','W','D','L','W'], zone:'',   pts:24 },
    { pos:7, name:'Heerenveen V',     short:'HEE', color:'#0033A0', p:20, w:5,  d:4, l:11,gf:22, ga:40, form:['L','D','L','W','D'], zone:'rel', pts:19 },
    { pos:8, name:'Sc Heerenveen',    short:'SCH', color:'#003399', p:20, w:3,  d:2, l:15,gf:15, ga:53, form:['L','L','D','L','L'], zone:'rel', pts:11 },
];
export const ERE_SCORERS = [
    { name:'Chasity Grant',    initials:'CG', club:'Ajax Vrouwen', goals:14 },
    { name:'Romée Leuchter',   initials:'RL', club:'FC Twente W',  goals:13 },
    { name:'Joëlle Smits',     initials:'JS', club:'PSV Vrouwen',  goals:11 },
    { name:'Lineth Beerensteyn',initials:'LB',club:'Ajax Vrouwen', goals:10 },
    { name:'Katja Snoeijs',    initials:'KS', club:'FC Twente W',  goals:9  },
];
export const ERE_FIXTURES = [
    { date:'2025-03-15', home:'Ajax Vrouwen', away:'FC Twente W',  homeGoals:2, ayGoals:1, status:'FT', homeColor:'#DC0714', awayColor:'#E4000F' },
    { date:'2025-03-22', home:'PSV Vrouwen',  away:'Feyenoord V',  homeGoals:3, awayGoals:0, status:'FT', homeColor:'#E30613', awayColor:'#CC0000' },
    { date:'2025-03-29', home:'FC Twente W',  away:'PSV Vrouwen',  homeGoals:2, awayGoals:2, status:'FT', homeColor:'#E4000F', awayColor:'#E30613' },
    { date:'2025-04-26', home:'Ajax Vrouwen', away:'PSV Vrouwen',  homeGoals:0, awayGoals:0, status:'NS', homeColor:'#DC0714', awayColor:'#E30613' },
    { date:'2025-05-03', home:'FC Twente W',  away:'Feyenoord V',  homeGoals:0, awayGoals:0, status:'NS', homeColor:'#E4000F', awayColor:'#CC0000' },
];
export function erePts(t) { return t.w * 3 + t.d; }
export function ereGD(t)  { return t.gf - t.ga; }

export async function fetchLiveEredivisieData() {
    const PROXY_URL = 'https://eredivisie-proxy.footballgirl.workers.dev';
    try {
        const res = await fetch(PROXY_URL, { signal: AbortSignal.timeout(5000) });
        if (!res.ok) throw new Error('HTTP ' + res.status);
        const data = await res.json();
        if (!data.standings || !data.standings.length) throw new Error('empty');
        return {
            standings: data.standings,
            scorers:   ERE_SCORERS,
            fixtures:  ERE_FIXTURES,
        };
    } catch (e) {
        console.warn('[fetchLiveEredivisieData] proxy failed, using fallback:', e.message);
        return null;
    }
}
